<template>
  <div class="player-team">
    <div v-if="seasonType.staff">
      <div class="tab-box">
        <ul class="tab-btn-list match">
          <li v-for="(tab, index) in tabList" :key="index" :class="{active:currentTab === index}"
              @click="tabIndexChange(currentTab)">
            <a href="#" @click.prevent="currentTab = index">{{ tab }}</a>
          </li>
        </ul>
      </div>

      <div v-if="currentTab === 0" class="tab-content">
        <Director />
      </div>
      <div v-if="currentTab === 1" class="tab-content">
        <Coach />
      </div>
      <div v-if="currentTab === 2" class="tab-content">
        <Staff />
      </div>
    </div>
    <div v-else>
      <PageComingSoon :titleText="' '" :descriptionText="String(seasonMsg)" />
    </div>
  </div>
</template>

<script>

import Director from '@/components/Player/Director.vue';
import Coach from '@/components/Player/Coach.vue';
import Staff from '@/components/Player/Staff.vue';
import PageComingSoon from '@/components/Common/PageComingSoon.vue';

export default {
  name: 'PlayerStaff',
  components: {PageComingSoon, Staff, Coach, Director},
  data() {
    return {
      currentTab: 0,
      tabList: ['감독', '코치', '스태프'],
      seasonType: this.$store.getters['getSeasonType'],
      seasonMsg: this.$store.getters['getSeasonMsg'],
    }
  },
  mounted () {
  },
  methods: {
    tabIndexChange(val) {
    },
  }
}
</script>
